<template>
  <!-- loaidng -->
  <div v-if="show" class="loading">
    <span>L</span>
    <span>o</span>
    <span>a</span>
    <span>d</span>
    <span>i</span>
    <span>n</span>
    <span>g</span>
  </div>
</template>
<script>
import Swiper from "swiper";
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/loading.vue